(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  if (!customElements.get('geobath-collection-sort')) {
    customElements.define('geobath-collection-sort', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.querySelector('form').addEventListener('submit', (event) => {
          event.preventDefault();
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', this.querySelector('[name="sort_by"]').value);
          url.searchParams.delete('page');
          window.location.assign(url.toString());
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.gb-contact [data-contact-result]').forEach((result) => result.focus());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["geobath-bath-bombs-destinations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gb-bath-destinations')) {
    customElements.define('gb-bath-destinations', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        this.requestedDestination = null;
        const select = (event) => {
          if (event.type === 'pointerover' && event.pointerType === 'touch') return;
          const entry = event.target.closest('[data-destination]');
          if (!entry || !this.contains(entry)) return;
          this.showDestination(entry);
        };
        for (const event of ['pointerover', 'focusin', 'click']) {
          this.addEventListener(event, select, { signal: this.events.signal });
        }
        document.addEventListener('shopify:block:select', select, { signal: this.events.signal });
      }

      disconnectedCallback() {
        this.events?.abort();
        this.requestedDestination = null;
      }

      async showDestination(entry) {
        const id = entry.dataset.destination;
        if (this.requestedDestination === id) return;
        this.requestedDestination = id;
        const photos = [...this.querySelectorAll('[data-destination-photo]')];
        const photo = photos.find((item) => item.dataset.destinationPhoto === id);
        const image = photo?.querySelector('img');
        let visiblePhoto = null;
        if (image) {
          image.loading = 'eager';
          try {
            await image.decode();
            visiblePhoto = photo;
          } catch {}
        }
        if (!this.isConnected || this.requestedDestination !== id) return;
        photos.forEach((item) => {
          const active = item === visiblePhoto;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-hidden', String(!active));
        });
        this.querySelectorAll('[data-destination-copy]').forEach((item) => {
          const active = item.dataset.destinationCopy === id;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-hidden', String(!active));
        });
        this.querySelectorAll('[data-destination]').forEach((item) => {
          item.querySelector('button').setAttribute('aria-pressed', String(item === entry));
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["geobath-bath-bombs-purchase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('geobath-bath-purchase')) customElements.define('geobath-bath-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enhanced) return;
      this.dataset.enhanced = 'true';
      const form = this.querySelector('form'), variant = this.querySelector('[data-variant]');
      if (!form || !variant) return;
      const quantity = form.elements.quantity, plan = this.querySelector('[data-plan]'), submit = this.querySelector('[data-submit]'), status = this.querySelector('[data-status]'), error = this.querySelector('[data-error-message]');
      const update = (rebuildPlans = false) => {
        const option = variant.selectedOptions[0], inCart = Number(option.dataset.cart), step = Number(option.dataset.step) || 1;
        const min = Math.max(Number(option.dataset.min) - inCart, step), max = option.dataset.max ? Math.max(0, Number(option.dataset.max) - inCart) : null;
        quantity.min = min; quantity.step = step;
        if (max !== null) quantity.max = max; else quantity.removeAttribute('max');
        if (rebuildPlans) quantity.value = min;
        if (plan && rebuildPlans) {
          const template = this.querySelector(`template[data-plans="${option.value}"]`);
          plan.replaceChildren();
          if (option.dataset.required !== 'true') plan.add(new Option(this.dataset.oneTime, ''));
          if (template) plan.append(template.content.cloneNode(true));
          plan.required = option.dataset.required === 'true';
          this.querySelector('[data-plan-field]').hidden = !template?.content.querySelector('option');
        }
        const validPlan = option.dataset.required !== 'true' || Boolean(plan?.value);
        const available = option.dataset.available === 'true';
        const allowed = available && validPlan && (max === null || max >= min);
        submit.disabled = !allowed;
        submit.textContent = allowed ? this.dataset.add : available ? this.dataset.limit : this.dataset.sold;
        status.textContent = allowed ? '' : available ? this.dataset.limit : this.dataset.sold;
        this.querySelector('[data-price]').textContent = plan?.selectedOptions[0]?.dataset.price || option.dataset.price;
        this.querySelector('[data-unit]').textContent = plan?.value ? '' : option.dataset.unit;
        const rules = this.querySelector('[data-rules]');
        if (rebuildPlans) rules.textContent = rules.dataset.pattern.replace('__MIN__', min).replace('__STEP__', step) + (max === null ? '' : ' ' + rules.dataset.maxPattern.replace('__MAX__', max)) + (inCart > 0 ? ' ' + rules.dataset.cartPattern.replace('__QUANTITY__', inCart) : '');
      };
      variant.addEventListener('change', () => { error.hidden = true; update(true); });
      plan?.addEventListener('change', () => update());
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (submit.disabled || !form.reportValidity()) return;
        error.hidden = true; submit.disabled = true; form.setAttribute('aria-busy', 'true'); status.textContent = this.dataset.busy;
        try {
          const response = await fetch(this.dataset.addUrl, {method: 'POST', body: new FormData(form), headers: {'Accept': 'application/json'}});
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' && result.description !== 'Cart Error' ? result.description : this.dataset.error);
          window.location.assign(this.dataset.cartUrl);
        } catch (failure) {
          error.textContent = failure instanceof TypeError ? this.dataset.error : failure.message || this.dataset.error; error.hidden = false; update(); form.removeAttribute('aria-busy');
        }
      });
      update();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["geobath-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('geobath-comparison')) {
    customElements.define('geobath-comparison', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const tabs = [...this.querySelectorAll('[role="tab"]')];
        const panels = [...this.querySelectorAll('[data-panel]')];
        const select = (tab, focus = false) => {
          tabs.forEach(item => {
            const active = item === tab;
            item.setAttribute('aria-selected', String(active));
            item.tabIndex = active ? 0 : -1;
          });
          panels.forEach(panel => { panel.hidden = panel.dataset.panel !== tab.dataset.group; });
          if (focus) tab.focus();
        };
        panels.forEach((panel, index) => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tabs[index].id);
        });
        this.querySelector('[role="tablist"]').hidden = false;
        this.dataset.enhanced = '';
        select(tabs[0]);
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => select(tab), { signal });
          tab.addEventListener('keydown', event => {
            let target;
            if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') target = (index - 1 + tabs.length) % tabs.length;
            if (event.key === 'Home') target = 0;
            if (event.key === 'End') target = tabs.length - 1;
            if (target === undefined) return;
            event.preventDefault();
            select(tabs[target], true);
          }, { signal });
        });
        this.addEventListener('shopify:block:select', event => {
          const panel = event.target.closest('[data-panel]');
          if (panel) select(tabs.find(tab => tab.dataset.group === panel.dataset.panel));
        }, { signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["geobath-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('geobath-hero-slideshow')) {
    customElements.define('geobath-hero-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-index]')];
        this.index = Number(this.dataset.active) || 0;
        this.paused = this.dataset.autoplay !== 'true';
        this.interval = Number(this.dataset.interval) || 10000;
        this.querySelector('.geobath-hero__controls').hidden = false;
        this.querySelector('[data-previous]').addEventListener('click', () => this.show(this.index - 1, true), options);
        this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1, true), options);
        this.dots.forEach(dot => dot.addEventListener('click', () => this.show(Number(dot.dataset.index), true), options));
        this.querySelector('[data-pause]')?.addEventListener('click', () => {
          this.paused = !this.paused;
          this.schedule();
        }, options);
        this.querySelector('.geobath-hero__controls').addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
          }
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.schedule();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.abort?.abort();
      }
      show(index, announce = false) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.dataset.active = String(this.index);
        this.slides.forEach((slide, position) => {
          slide.classList.toggle('is-active', position === this.index);
          slide.setAttribute('aria-hidden', String(position !== this.index));
        });
        this.dots.forEach((dot, position) => dot.setAttribute('aria-pressed', String(position === this.index)));
        if (announce) {
          this.querySelector('.geobath-hero__status').textContent = this.dots[this.index].getAttribute('aria-label');
        }
        this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        const pause = this.querySelector('[data-pause-label]');
        const play = this.querySelector('[data-play-label]');
        if (pause && play) { pause.hidden = this.paused; play.hidden = !this.paused; }
        if (this.paused || document.hidden) return;
        this.timer = setTimeout(() => this.show(this.index + 1), this.interval);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["geobath-ingredient-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:block:select', event => {
    event.target.closest('.geobath-ingredients')?.setAttribute('data-editor-paused', '');
  });
  document.addEventListener('shopify:block:deselect', event => {
    event.target.closest('.geobath-ingredients')?.removeAttribute('data-editor-paused');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["geobath-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('geobath-recommendations')) {
    customElements.define('geobath-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.manual || this.loaded) return;
        this.loaded = true;
        this.controller = new AbortController();
        fetch(this.dataset.url, { signal: this.controller.signal })
          .then(response => { if (!response.ok) throw new Error('Recommendations unavailable'); return response.text(); })
          .then(text => {
            const html = new DOMParser().parseFromString(text, 'text/html');
            const content = html.querySelector('[data-recommendations-content]');
            if (content && !content.hidden) this.querySelector('[data-recommendations-content]').replaceWith(content);
          })
          .catch(() => { this.loaded = false; });
      }
      disconnectedCallback() { this.controller?.abort(); this.loaded = false; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["geobath-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('geobath-products')) {
    customElements.define('geobath-products', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-enhanced')) return;
        const tablist = this.querySelector('[role="tablist"]');
        const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
        const panels = Array.from(this.querySelectorAll('[data-panel]'));
        const select = (tab, focus = false) => {
          tabs.forEach((item) => {
            const active = item === tab;
            item.setAttribute('aria-selected', String(active));
            item.tabIndex = active ? 0 : -1;
          });
          panels.forEach((panel) => { panel.hidden = panel.dataset.panel !== tab.dataset.group; });
          if (focus) tab.focus();
        };
        panels.forEach((panel, index) => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tabs[index].id);
          panel.tabIndex = 0;
        });
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => select(tab));
          tab.addEventListener('keydown', (event) => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            select(tabs[next], true);
          });
        });
        select(tabs[0]);
        tablist.hidden = false;
        this.setAttribute('data-enhanced', '');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["geobath-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('geobath-review-categories')) {
    customElements.define('geobath-review-categories', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.reviews = Array.from(this.querySelectorAll('[data-review]'));
        this.buttons = Array.from(this.querySelectorAll('[data-category]'));
        this.more = this.querySelector('[data-show-more]');
        this.status = this.querySelector('[data-status]');
        this.category = 'all';
        this.limit = 3;
        this.buttons.forEach(button => button.addEventListener('click', () => {
          this.category = button.dataset.category;
          this.limit = 3;
          this.update();
        }, options));
        this.more.addEventListener('click', () => {
          const firstNewReview = this.matches[this.limit];
          this.limit += 3;
          this.update();
          if (firstNewReview) {
            firstNewReview.tabIndex = -1;
            firstNewReview.focus({ preventScroll: true });
          }
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.reviews.findIndex(review => review.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.category = 'all';
          this.limit = Math.ceil((index + 1) / 3) * 3;
          this.update();
        }, options);
        this.querySelector('.geobath-reviews__filters').hidden = false;
        this.status.hidden = false;
        this.update();
      }
      update() {
        this.matches = this.reviews.filter(review => this.category === 'all' || review.dataset.categories.split(' ').includes(this.category));
        const visible = new Set(this.matches.slice(0, this.limit));
        this.reviews.forEach(review => { review.hidden = !visible.has(review); });
        this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.category === this.category)));
        this.more.hidden = this.matches.length <= this.limit;
        this.status.textContent = this.status.dataset.countTemplate.replace('[shown]', String(visible.size)).replace('[total]', String(this.matches.length));
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('geobath-header')) {
    customElements.define('geobath-header', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.updateScroll = () => this.classList.toggle('is-scrolled', window.scrollY > 32);
        this.updateScroll();
        window.addEventListener('scroll', this.updateScroll, { passive: true, signal });
        window.addEventListener('pageshow', this.updateScroll, { signal });
        const dropdowns = [...this.querySelectorAll('.geobath-header__dropdown')];
        const desktopHover = window.matchMedia('(min-width: 1100px) and (hover: hover)');
        dropdowns.forEach((dropdown) => {
          const group = dropdown.closest('.geobath-header__collection');
          group.addEventListener('pointerenter', () => {
            if (!desktopHover.matches) return;
            dropdowns.forEach((other) => { if (other !== dropdown) other.open = false; });
            dropdown.open = true;
          }, { signal });
          group.addEventListener('pointerleave', () => {
            if (desktopHover.matches && !group.contains(document.activeElement)) dropdown.open = false;
          }, { signal });
          group.addEventListener('focusout', (event) => {
            if (!group.contains(event.relatedTarget)) dropdown.open = false;
          }, { signal });
          group.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && dropdown.open) {
              event.stopPropagation();
              dropdown.open = false;
              dropdown.querySelector('summary').focus();
            }
          }, { signal });
        });
        document.addEventListener('click', (event) => {
          dropdowns.forEach((dropdown) => {
            if (!dropdown.closest('.geobath-header__collection').contains(event.target)) dropdown.open = false;
          });
        }, { signal });
        const menu = this.querySelector('.geobath-header__mobile');
        if (menu) {
          this.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && menu.open) {
              menu.open = false;
              menu.querySelector('summary').focus();
            }
          }, { signal });
          document.addEventListener('click', (event) => {
            if (!menu.contains(event.target)) menu.open = false;
          }, { signal });
          menu.addEventListener('click', (event) => {
            if (event.target.closest('a')) menu.open = false;
          }, { signal });
        }
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!customElements.get('geobath-product')) {
    customElements.define('geobath-product', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enhanced) return;
        this.dataset.enhanced = 'true';
        this.controller = new AbortController();
        const listenerOptions = { signal: this.controller.signal };
        const select = this.querySelector('[data-variant]');
        const quantity = this.querySelector('[name="quantity"]');
        const media = Array.from(this.querySelectorAll('[data-media-id]'));
        const thumbnails = Array.from(this.querySelectorAll('[data-thumbnail]'));
        const showMedia = (id) => {
          if (!media.some(item => item.dataset.mediaId === id)) return;
          media.forEach(item => {
            const active = item.dataset.mediaId === id;
            if (!active && !item.hidden) {
              item.querySelectorAll('video').forEach(video => video.pause());
              item.querySelectorAll('iframe').forEach(frame => { frame.src = frame.src; });
            }
            item.hidden = !active;
          });
          thumbnails.forEach(link => {
            if (link.dataset.thumbnail === id) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
          });
        };
        thumbnails.forEach(link => link.addEventListener('click', event => {
          event.preventDefault();
          showMedia(link.dataset.thumbnail);
        }, listenerOptions));
        showMedia(this.dataset.initialMedia);
        const updatePrice = () => {
          const option = select.selectedOptions[0];
          const plan = this.querySelector('[name="selling_plan"]')?.selectedOptions[0];
          const allocation = plan?.value ? plan.dataset : null;
          const price = allocation?.price || option.dataset.price;
          const compare = allocation ? allocation.compare : option.dataset.compare;
          const unit = allocation ? allocation.unit : option.dataset.unit;
          this.querySelector('[data-price]').textContent = price;
          this.querySelector('[data-sticky-price]').textContent = price;
          this.querySelector('[data-compare]').hidden = !compare;
          this.querySelector('[data-compare-value]').textContent = compare || '';
          this.querySelector('[data-unit]').hidden = !unit;
          this.querySelector('[data-unit]').textContent = unit || '';
          const purchasable = option.dataset.available === 'true' && !(option.dataset.required === 'true' && option.dataset.planCount === '0');
          const submit = this.querySelector('[data-submit]');
          submit.disabled = !purchasable;
          submit.textContent = purchasable ? this.dataset.addLabel : option.dataset.available === 'true' ? this.dataset.unavailableLabel : this.dataset.soldLabel;
          const checkout = this.querySelector('[data-checkout]');
          if (checkout) checkout.hidden = !purchasable;
        };
        const updateUrl = () => {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', select.value);
          const plan = this.querySelector('[name="selling_plan"]');
          if (plan && !plan.disabled && plan.value) url.searchParams.set('selling_plan', plan.value);
          else url.searchParams.delete('selling_plan');
          window.history.replaceState({}, '', url);
        };
        this.addEventListener('geobath:plan-change', () => { updatePrice(); updateUrl(); }, listenerOptions);
        const updateVariant = () => {
          const option = select.selectedOptions[0];
          if (!option) return;
          const available = option.dataset.available === 'true';

          this.querySelector('[data-availability]').textContent = available ? this.dataset.availableLabel : this.dataset.soldLabel;
          const submit = this.querySelector('[data-submit]');
          submit.disabled = !available;
          submit.textContent = available ? this.dataset.addLabel : this.dataset.soldLabel;
          updatePrice();
          quantity.min = option.dataset.min || '1';
          quantity.step = option.dataset.step || '1';
          if (option.dataset.max) quantity.max = option.dataset.max;
          else quantity.removeAttribute('max');
          quantity.value = quantity.min;
          showMedia(option.dataset.media);
          updateUrl();
        };
        select.addEventListener('change', updateVariant, listenerOptions);
        updatePrice();
        this.setupStickyPurchase();
        this.querySelectorAll('[data-quantity-change]').forEach(button => {
          button.hidden = false;
          button.addEventListener('click', () => {
            if (!quantity.value) quantity.value = quantity.min;
            if (button.dataset.quantityChange === '1') quantity.stepUp();
            else quantity.stepDown();
            quantity.dispatchEvent(new Event('change', { bubbles: true }));
          }, listenerOptions);
        });
      }
      setupStickyPurchase() {
        if (this.dataset.stickyEnabled !== 'true') return;
        const anchor = this.querySelector('[data-purchase-anchor]');
        const controls = this.querySelector('[data-purchase-controls]');
        const summary = this.querySelector('[data-sticky-summary]');
        let editing = false;
        this.primeObservers = new Map();
        let frame;
        const measure = () => {
          if (controls.classList.contains('is-floating')) {
            document.body.style.setProperty('--gb-purchase-height', `${controls.offsetHeight}px`);
          } else {
            anchor.style.minHeight = `${controls.offsetHeight}px`;
          }
        };
        const update = () => {
          frame = null;
          const passed = anchor.getBoundingClientRect().bottom <= 0;
          if (!passed) editing = false;
          const floating = passed && !editing;
          if (floating !== controls.classList.contains('is-floating')) {
            if (floating) anchor.style.minHeight = `${controls.offsetHeight}px`;
            controls.classList.toggle('is-floating', floating);
            summary.hidden = !floating;
          }
          this.compactCheckout(controls);
          measure();
        };
        const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
        this.stickyAbort = new AbortController();
        window.addEventListener('scroll', schedule, { passive: true, signal: this.stickyAbort.signal });
        window.addEventListener('resize', schedule, { signal: this.stickyAbort.signal });
        this.querySelector('[data-edit-options]').addEventListener('click', () => {
          editing = true;
          update();
          const field = !selectHidden(this.querySelector('[data-variant]')) ? this.querySelector('[data-variant]') : this.querySelector('[name="selling_plan"]:not(:disabled)') || this.querySelector('[name="quantity"]');
          field.scrollIntoView({ block: 'center', behavior: 'instant' });
          field.focus({ preventScroll: true });
        }, { signal: this.stickyAbort.signal });
        function selectHidden(field) { return field.closest('[hidden]') !== null; }
        this.stickyMutation = new MutationObserver(schedule);
        this.stickyMutation.observe(this, { childList: true, subtree: true });
        this.stickyResize = new ResizeObserver(schedule);
        this.stickyResize.observe(controls);
        update();
      }
      compactCheckout(controls) {
        const checkout = this.querySelector('[data-checkout]');
        if (!checkout) return;
        const accelerated = checkout.querySelector('shopify-accelerated-checkout');
        const wallet = Array.from(accelerated?.children || []).find(child => child.tagName.endsWith('-BUTTON'));
        if (wallet) {
          wallet.setAttribute('data-gb-wallet', '');
          const buttonWidth = this.querySelector('[data-submit]').getBoundingClientRect().width;
          wallet.style.setProperty('--gb-wallet-scale', String(Math.min(1, buttonWidth / 140)));
        }
        const prime = this.querySelector('delivery-promise-wc');
        const root = prime?.shadowRoot;
        if (prime) prime.toggleAttribute('data-gb-external-prime', !checkout.contains(prime));
        if (!root) return;
        if (!root.querySelector('[data-gb-compact-style]')) {
          const style = document.createElement('style');
          style.setAttribute('data-gb-compact-style', '');
          style.textContent = `
            :host([data-gb-floating]) .AmazonLayout__AmazonContainer { display: none !important; }
            :host([data-gb-floating]) .ProductPageContainer__Spacer,
            :host([data-gb-floating]) .PromiseShell__Content,
            :host([data-gb-floating]) .PromiseShell__Promise,
            :host([data-gb-floating]) .BuyWithPrimeButton__container { padding: 0 !important; margin: 0 !important; min-height: 0 !important; }
            :host([data-gb-floating]) .PromiseShell__ShopPromise-SmoothContainer { height: auto !important; min-height: 0 !important; }
            :host([data-gb-floating]) .BlockStack__BlockStack { gap: 0 !important; }
            :host([data-gb-floating]) .BuyWithPrimeButton__buy-with-prime-button { width: 100% !important; height: 36px !important; min-height: 36px !important; padding: 4px 8px !important; border-radius: 6px !important; }
            :host([data-gb-floating]) .BuyWithPrimeButton__logo { max-width: 100%; max-height: 24px; object-fit: contain; }
          `;
          root.append(style);
        }
        const hasPrime = !!root.querySelector('.BuyWithPrimeButton__buy-with-prime-button');
        checkout.toggleAttribute('data-has-prime', hasPrime);
        prime.toggleAttribute('data-gb-prime-button', hasPrime);
        const floating = controls.classList.contains('is-floating');
        prime.toggleAttribute('data-gb-floating', floating);
        if (floating && hasPrime) {
          const rect = checkout.getBoundingClientRect();
          prime.style.setProperty('--gb-prime-button-width', `${this.querySelector('[data-submit]').getBoundingClientRect().width}px`);
          prime.style.setProperty('--gb-prime-right', `${window.innerWidth - rect.right}px`);
          prime.style.setProperty('--gb-prime-bottom', `${window.innerHeight - rect.bottom}px`);
        }
        if (!this.primeObservers.has(root)) {
          const observer = new MutationObserver(() => this.compactCheckout(controls));
          observer.observe(root, { childList: true, subtree: true });
          this.primeObservers.set(root, observer);
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.stickyAbort?.abort();
        this.stickyResize?.disconnect();
        this.stickyMutation?.disconnect();
        this.primeObservers?.forEach(observer => observer.disconnect());
        delete this.dataset.enhanced;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stiimpak-shower-steamers-purchase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('stiimpak-discovery-purchase')) customElements.define('stiimpak-discovery-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enhanced) return;
      this.dataset.enhanced = 'true';
      const form = this.querySelector('form'), variant = this.querySelector('[data-variant]');
      if (!form || !variant) return;
      const quantity = form.elements.quantity, plan = this.querySelector('[data-plan]'), submit = this.querySelector('[data-submit]'), status = this.querySelector('[data-status]'), error = this.querySelector('[data-error-message]');
      const update = (rebuildPlans = false) => {
        const option = variant.selectedOptions[0], step = Number(option.dataset.step) || 1, inCart = Number(option.dataset.cart) || 0;
        const min = Math.max(Number(option.dataset.min) - inCart, step), max = option.dataset.max ? Math.max(0, Number(option.dataset.max) - inCart) : null;
        quantity.min = min; quantity.step = step;
        if (max !== null) quantity.max = max; else quantity.removeAttribute('max');
        if (rebuildPlans) quantity.value = min;
        if (plan && rebuildPlans) {
          const template = this.querySelector('template[data-plans="' + option.value + '"]');
          plan.replaceChildren();
          if (option.dataset.required !== 'true') plan.add(new Option(this.dataset.oneTime, ''));
          if (template) plan.append(template.content.cloneNode(true));
        }
        if (plan) {
          plan.required = option.dataset.required === 'true';
          const hasPlans = Boolean(this.querySelector('template[data-plans="' + option.value + '"]')?.content.querySelector('option'));
          this.querySelector('[data-plan-field]').hidden = !hasPlans;
          plan.disabled = !hasPlans;
        }
        const validPlan = option.dataset.required !== 'true' || Boolean(plan?.value), available = option.dataset.available === 'true';
        const allowed = available && validPlan && (max === null || max >= min);
        submit.disabled = !allowed;
        submit.textContent = allowed ? this.dataset.add : available ? this.dataset.unavailable : this.dataset.sold;
        status.textContent = allowed ? '' : available ? (validPlan ? this.dataset.limit : this.dataset.unavailable) : this.dataset.sold;
        this.querySelector('[data-availability]').textContent = available ? this.dataset.available : this.dataset.sold;
        this.querySelector('[data-price]').textContent = plan?.value ? plan.selectedOptions[0].dataset.price : option.dataset.price;
        this.querySelector('[data-unit]').textContent = plan?.value ? '' : option.dataset.unit;
        const rules = this.querySelector('[data-rules]');
        rules.textContent = rules.dataset.pattern.replace('__MIN__', min).replace('__STEP__', step) + (max === null ? '' : ' ' + rules.dataset.maxPattern.replace('__MAX__', max)) + (inCart > 0 ? ' ' + rules.dataset.cartPattern.replace('__QUANTITY__', inCart) : '');
        this.querySelector('[data-quantity-change="-1"]').disabled = Number(quantity.value) <= min;
        this.querySelector('[data-quantity-change="1"]').disabled = max !== null && Number(quantity.value) + step > max;
        if (rebuildPlans && option.dataset.image) {
          const image = this.querySelector('.stiimpak-purchase__image');
          if (image) { image.removeAttribute('srcset'); image.src = option.dataset.image; image.alt = option.dataset.alt; }
        }
      };
      variant.addEventListener('change', () => { error.hidden = true; update(true); });
      plan?.addEventListener('change', () => update());
      quantity.addEventListener('input', () => update());
      this.querySelectorAll('[data-quantity-change]').forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => {
          if (!quantity.value) quantity.value = quantity.min;
          if (button.dataset.quantityChange === '1') quantity.stepUp(); else quantity.stepDown();
          update();
        });
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (submit.disabled || form.getAttribute('aria-busy') === 'true' || !form.reportValidity()) return;
        error.hidden = true; submit.disabled = true; form.setAttribute('aria-busy', 'true'); status.textContent = this.dataset.busy;
        try {
          const cartResponse = await fetch(this.dataset.cartUrl + '.js', {headers: {'Accept': 'application/json'}});
          if (!cartResponse.ok) throw new Error(this.dataset.error);
          const cart = await cartResponse.json();
          for (const option of variant.options) option.dataset.cart = cart.items.filter(item => String(item.variant_id) === option.value).reduce((sum, item) => sum + item.quantity, 0);
          update();
          if (submit.disabled || !form.reportValidity()) return;
          submit.disabled = true; status.textContent = this.dataset.busy;
          const response = await fetch(this.dataset.addUrl, {method: 'POST', body: new FormData(form), headers: {'Accept': 'application/json'}});
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' && result.description !== 'Cart Error' ? result.description : this.dataset.error);
          window.location.assign(this.dataset.cartUrl);
        } catch (failure) {
          error.textContent = failure instanceof TypeError ? this.dataset.error : failure.message || this.dataset.error;
          error.hidden = false; error.focus(); update();
        } finally {
          form.removeAttribute('aria-busy');
        }
      });
      update();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
